import "../styles/css/request-estimate.css"
import {useState} from "react";
const NoEstimateRequestAvailablePage: React.FC = () => {
    return (
        <div className='request-body'>
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    <p>Lorem ipsum no estimate is ready to be scheduled at this time yada yada.</p>
                    <p>(123) 123-1234<br/><a href="mailto:email@barreca.com">email@barreca.com</a></p>
                </div>
            </div>
        </div>
    )
}
export default NoEstimateRequestAvailablePage;